import {createBrowserHistory} from 'history';

function createHistory() {

  const baseName = '';

  return createBrowserHistory({basename: baseName});
}

export {
  createHistory,
};
